/**
 * Full-screen fallback for an error nothing else caught (a render error, a failed lazy chunk).
 * Reloading the page is the one way out: re-rendering the same tree would hit the same error.
 */
export function CrashScreen({ error }: { error: Error }): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-paper px-6 text-center">
      <h1 className="font-display text-display-lg text-ink">Something broke.</h1>
      <p className="text-body text-ink-secondary max-w-md">
        We hit an unexpected error. Reload to try again. If it keeps happening, send the
        report below to support.
      </p>
      <pre className="rounded-md hairline bg-sunken px-4 py-3 text-mono-sm text-ink-secondary max-w-full overflow-auto">
        {error.message}
      </pre>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-sm bg-primary-600 px-5 py-2 text-label text-[color:var(--primary-ink)]"
      >
        Reload
      </button>
    </div>
  );
}
